module.exports = __webpack_public_path__ + "static/media/empty-campaign.e89cde94.svg";


//////////////////
// WEBPACK FOOTER
// ./src/statsradio/assets/img/empty-campaign.svg
// module id = ./src/statsradio/assets/img/empty-campaign.svg
// module chunks = 18